// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"style_InputLabel__2kr8V","description":"style_description__DXTGE","mark":"style_mark__37v3p","height":"style_height__3vOUg"};